"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_3_keyboard = _interopRequireDefault(require("../images/help_3_keyboard.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyboardMode = {
  id: "keyboardMode",
  title: {
    en: "keyboard mode",
    de: "Tastatur-Modus"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_3_keyboard.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Move (keyboard mode)"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Press starting point choice key (F12) to view 1st person, 3rd person view, 3rd person widow preview selection")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Starting point of 1st , 3rd person view", /*#__PURE__*/_react.default.createElement("div", null, "W: Move forward"), /*#__PURE__*/_react.default.createElement("div", null, "S: Move backward"), /*#__PURE__*/_react.default.createElement("div", null, "A: Move left"), /*#__PURE__*/_react.default.createElement("div", null, "D: Move right"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Starting point for 3rd person view preview", /*#__PURE__*/_react.default.createElement("div", null, "W: move forward"), /*#__PURE__*/_react.default.createElement("div", null, "S: move backward"), /*#__PURE__*/_react.default.createElement("div", null, "A: Character can turn left: Camera is fixed"), /*#__PURE__*/_react.default.createElement("div", null, "D: Character can turn right: Camera is fixed"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Press Tab key to run in the same direction as you were facing"))))
  }
};
var _default = keyboardMode;
exports.default = _default;